import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPortfolioOverviewDisplayed } from '../../models/products.model';

@Component({
  selector: 'liberro-portfolios-overview-list',
  standalone: false,
  templateUrl: './liberro-portfolios-overview-list.component.html',
  styleUrl: './liberro-portfolios-overview-list.component.less'
})
export class LiberroPortfoliosOverviewListComponent {

  @Input() public portfoliosList: IPortfolioOverviewDisplayed[] = [];
  @Input() public showViewMore = false;
  @Input() public loading = false;
  @Input() public hasErrored = false;
  @Output() public portfolioSelected = new EventEmitter<number>();
  @Output() public viewMoreClicked = new EventEmitter<void>();

  public selectPortfolio(portfolioId: number): void {
    this.portfolioSelected.emit(portfolioId);
  }

  public viewMorePortfolios(): void {
    this.viewMoreClicked.emit();
  }

}
